export default {
  FETCH_STEWARD_BUSINESSPARTNER_LISTS: "FETCH_STEWARD_BUSINESSPARTNER_LISTS",
  FETCH_STEWARD_BUSINESSPARTNER_LISTS_SUCCEEDED:
    "FETCH_STEWARD_BUSINESSPARTNER_LISTS_SUCCEEDED"
};
